<template>
  <a href="#"
     class="button dropdown region-selector-trigger"
     @click.prevent="$emit('click')"
     v-html="title"/>
</template>

<script>
export default {
  name: 'RegionSelectorTrigger',
  props: {
    selectedRegions: {
      type: Array,
      required: true
    }
  },
  computed: {
    title () {
      return this.selectedRegions.length === 0
        ? this.$t('productOverview.selectRegion')
        : this.$t('productOverview.changeRegionSelection')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegionSelectorTrigger.vue